import gql from 'graphql-tag';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type AppendEventInput = {
  shortId: Scalars['ID'];
  words: Array<WordInputType>;
};

export type CreateEncoderInput = {
  ip: Scalars['String'];
  port: Scalars['String'];
  type: Scalars['String'];
};

export type CreateEventInput = {
  service?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  encoder?: Maybe<Scalars['String']>;
  completed?: Maybe<Scalars['Boolean']>;
  archived?: Maybe<Scalars['Boolean']>;
  profileId?: Maybe<Scalars['Int']>;
};

export type CreateUserInput = {
  password?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  role: Scalars['String'];
  username: Scalars['String'];
  shortId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Scalars['String']>>;
  settings?: Maybe<Array<SettingGql>>;
  audioTtl?: Maybe<Scalars['Int']>;
  retainAudio?: Maybe<Scalars['Boolean']>;
  minDisplayTime?: Maybe<Scalars['Int']>;
  ownerId?: Maybe<Scalars['Int']>;
};

export type EncoderGql = {
  __typename?: 'EncoderGql';
  uuid: Scalars['ID'];
  ip: Scalars['String'];
  port: Scalars['String'];
  type: Scalars['String'];
};

export type Event = {
  __typename?: 'Event';
  shortId: Scalars['ID'];
  title?: Maybe<Scalars['String']>;
  service?: Maybe<Scalars['String']>;
  dictationTime?: Maybe<Scalars['Float']>;
  link?: Maybe<Scalars['String']>;
  encoder?: Maybe<Scalars['String']>;
  completed: Scalars['Boolean'];
  canEdit?: Maybe<Scalars['Boolean']>;
  archived: Scalars['Boolean'];
  image?: Maybe<Scalars['String']>;
  useZoomCaptions?: Maybe<Scalars['Boolean']>;
  zoomAPIKey?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  uppercase?: Maybe<Scalars['Boolean']>;
  storagePath?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['Int']>;
};

export type EventEdge = {
  __typename?: 'EventEdge';
  cursor: Scalars['String'];
  node: Event;
};

export type FilterArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['Float']>;
  filter?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  onlyMine?: Maybe<Scalars['Boolean']>;
};

export type LectureResults = {
  __typename?: 'LectureResults';
  totalCount: Scalars['Int'];
  edges: Array<EventEdge>;
  pageInfo: PageInfo;
};

export type LinkGql = {
  __typename?: 'LinkGql';
  uuid: Scalars['ID'];
  link: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  appendEvent: Event;
  updateEvent: Event;
  createEvent: Event;
  createUser: UserGql;
  updateUser: UserGql;
  updateProfile: UserGql;
  createLink: LinkGql;
  removeLink: Scalars['Boolean'];
  createEncoder: EncoderGql;
  deleteEncoder: EncoderGql;
};

export type MutationAppendEventArgs = {
  input: AppendEventInput;
};

export type MutationUpdateEventArgs = {
  input: UpdateEventInput;
};

export type MutationCreateEventArgs = {
  input: CreateEventInput;
};

export type MutationCreateUserArgs = {
  user: CreateUserInput;
};

export type MutationUpdateUserArgs = {
  user: CreateUserInput;
};

export type MutationUpdateProfileArgs = {
  user: UpdateUserInput;
};

export type MutationCreateLinkArgs = {
  link: Scalars['String'];
};

export type MutationRemoveLinkArgs = {
  link: Scalars['String'];
};

export type MutationCreateEncoderArgs = {
  encoder: CreateEncoderInput;
};

export type MutationDeleteEncoderArgs = {
  id: Scalars['String'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Scalars['String'];
  hasNextPage: Scalars['Boolean'];
};

export type PermissionGql = {
  __typename?: 'PermissionGql';
  uuid: Scalars['ID'];
  name: Scalars['String'];
};

export type SettingGql = {
  __typename?: 'SettingGql';
  key: Scalars['String'];
  value: Scalars['String'];
}

export type Query = {
  __typename?: 'Query';
  events: LectureResults;
  event: Event;
  users: UserResults;
  user: UserGql;
  currentUser: UserGql;
  uploads: UploadResults;
  encoders: Array<EncoderGql>;
};

export type QueryEventsArgs = {
  filters: FilterArgs;
};

export type QueryEventArgs = {
  input: SingleEventInput;
};

export type QueryUsersArgs = {
  filters: FilterArgs;
};

export type QueryUserArgs = {
  shortId: Scalars['String'];
};

export type QueryUploadsArgs = {
  filters: FilterArgs;
};

export type SingleEventInput = {
  shortId: Scalars['ID'];
  language?: Maybe<Scalars['String']>;
  window?: Maybe<Scalars['Float']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  eventAppended: Event;
};

export type SubscriptionEventAppendedArgs = {
  input: SingleEventInput;
};

export type UpdateEventInput = {
  title?: Maybe<Scalars['String']>;
  visibility?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  completed?: Maybe<Scalars['Boolean']>;
  encoder?: Maybe<Scalars['String']>;
  shortId: Scalars['String'];
  useZoomCaptions?: Maybe<Scalars['Boolean']>;
  zoomAPIKey?: Maybe<Scalars['String']>;
  uppercase?: Maybe<Scalars['Boolean']>;
};

export type UpdateUserInput = {
  shortId: Scalars['String'];
  password?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Scalars['String']>>;
  settings?: Maybe<Array<Scalars['String']>>;
};

export type Upload = {
  __typename?: 'Upload';
  shortId: Scalars['ID'];
  filename: Scalars['String'];
  status: Scalars['String'];
  event?: Maybe<Event>;
};

export type UploadEdge = {
  __typename?: 'UploadEdge';
  cursor: Scalars['String'];
  node: Upload;
};

export type UploadResults = {
  __typename?: 'UploadResults';
  totalCount: Scalars['Int'];
  edges: Array<UploadEdge>;
  pageInfo: PageInfo;
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['String'];
  node: UserGql;
};

export type UserGql = {
  __typename?: 'UserGQL';
  shortId: Scalars['ID'];
  username: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  role: Scalars['String'];
  header?: Maybe<Scalars['String']>;
  permissions: Array<PermissionGql>;
  logo?: Maybe<Scalars['String']>;
  events?: Maybe<Array<Event>>;
  links?: Maybe<Array<LinkGql>>;
  encoders?: Maybe<Array<EncoderGql>>;
  settings?: Maybe<Array<SettingGql>>;
  uncompletedEvent?: Maybe<Event>;
  ownerId?: Scalars['Int'];
};

export type UserResults = {
  __typename?: 'UserResults';
  totalCount: Scalars['Int'];
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
};

export type Word = {
  __typename?: 'Word';
  startTime: Scalars['String'];
  endTime: Scalars['String'];
  word: Scalars['String'];
};

export type WordInputType = {
  startTime: Scalars['String'];
  word: Scalars['String'];
};

export type CreateEncoderMutationVariables = {
  encoder: CreateEncoderInput;
};

export type CreateEncoderMutation = { __typename?: 'Mutation' } & {
  createEncoder: { __typename?: 'EncoderGql' } & Pick<
    EncoderGql,
    'uuid' | 'ip' | 'port' | 'type'
  >;
};

export type CreateLinkMutationVariables = {
  link: Scalars['String'];
};

export type CreateLinkMutation = { __typename?: 'Mutation' } & {
  createLink: { __typename?: 'LinkGql' } & Pick<LinkGql, 'uuid' | 'link'>;
};

export type CreateUserMutationVariables = {
  user: CreateUserInput;
};

export type CreateUserMutation = { __typename?: 'Mutation' } & {
  createUser: { __typename?: 'UserGQL' } & Pick<
    UserGql,
    'shortId' | 'username' | 'firstName' | 'lastName' | 'email'
  >;
};

export type DeleteEncoderMutationVariables = {
  input: {
    id: Scalars['String'];
  }
};

export type DeleteEncoderMutation = { __typename?: 'Mutation' } & {
  deleteEncoder: { __typename?: 'EncoderGql' } & Pick<EncoderGql, 'uuid'>;
};

export type EventsQueryVariables = {
  filters: FilterArgs;
};

export type EventsQuery = { __typename?: 'Query' } & {
  events: { __typename?: 'LectureResults' } & Pick<
    LectureResults,
    'totalCount'
  > & {
      edges: Array<
        { __typename?: 'EventEdge' } & Pick<EventEdge, 'cursor'> & {
            node: { __typename?: 'Event' } & Pick<
              Event,
              'shortId' | 'title' | 'image' | 'dictationTime' | 'completed' | 'storagePath'
            >;
          }
      >;
    };
};

export type EventQueryVariables = {
  input: SingleEventInput;
};

export type EventQuery = { __typename?: 'Query' } & {
  event: { __typename?: 'Event' } & Pick<
    Event,
    | 'shortId'
    | 'title'
    | 'service'
    | 'canEdit'
    | 'encoder'
    | 'completed'
    | 'link'
    | 'image'
    | 'zoomAPIKey'
    | 'useZoomCaptions'
    | 'uppercase'
    | 'storagePath'
    | 'visibility'
    | 'profileId'
  >;
};

export type AppendEventMutationVariables = {
  input: AppendEventInput;
};

export type AppendEventMutation = { __typename?: 'Mutation' } & {
  appendEvent: { __typename?: 'Event' } & Pick<Event, 'shortId' | 'title'> & {
      words: Maybe<
        Array<{ __typename?: 'Word' } & Pick<Word, 'startTime' | 'word'>>
      >;
    };
};

export type OnEventAppendedSubscriptionVariables = {
  input: SingleEventInput;
};

export type OnEventAppendedSubscription = { __typename?: 'Subscription' } & {
  eventAppended: { __typename?: 'Event' } & Pick<Event, 'shortId'> & {
      words: Maybe<
        Array<{ __typename?: 'Word' } & Pick<Word, 'startTime' | 'word'>>
      >;
    };
};

export type CreateEventMutationVariables = {
  input: CreateEventInput;
};

export type CreateEventMutation = {
  __typename?: 'Mutation';
  createEvent: {
    __typename?: 'Event';
    shortId: string;
    profile?: {
      id?: number;
      name?: string;
      theme?: string;
      backgroundColor?: string;
      fontColor?: string;
      fontFamily?: string;
      fontSize?: number;
      language?: string;
      fullscreen?: boolean;
    } | null;
  };
};

export type RemoveLinkMutationVariables = {
  link: Scalars['String'];
};

export type RemoveLinkMutation = { __typename?: 'Mutation' } & Pick<
  Mutation,
  'removeLink'
>;

export type UpdateEventMutationVariables = {
  input: UpdateEventInput;
};

export type UpdateEventMutation = { __typename?: 'Mutation' } & {
  updateEvent: { __typename?: 'Event' } & Pick<
    Event,
    | 'shortId'
    | 'title'
    | 'service'
    | 'dictationTime'
    | 'completed'
    | 'canEdit'
    | 'encoder'
    | 'archived'
    | 'uppercase'
  >;
};

export type UpdateProfileMutationVariables = {
  user: UpdateUserInput;
};

export type UpdateProfileMutation = { __typename?: 'Mutation' } & {
  updateProfile: { __typename?: 'UserGQL' } & Pick<
    UserGql,
    'shortId' | 'username' | 'header' | 'firstName' | 'lastName' | 'email'
  >;
};

export type UpdateUserMutationVariables = {
  user: CreateUserInput;
};

export type UpdateUserMutation = { __typename?: 'Mutation' } & {
  updateUser: { __typename?: 'UserGQL' } & Pick<
    UserGql,
    'shortId' | 'username' | 'firstName' | 'lastName' | 'email'
  >;
};

export type UploadsQueryVariables = {
  filters: FilterArgs;
};

export type UploadsQuery = { __typename?: 'Query' } & {
  uploads: { __typename?: 'UploadResults' } & Pick<
    UploadResults,
    'totalCount'
  > & {
      edges: Array<
        { __typename?: 'UploadEdge' } & Pick<UploadEdge, 'cursor'> & {
            node: { __typename?: 'Upload' } & Pick<
              Upload,
              'shortId' | 'filename' | 'status'
            > & {
                event: Maybe<{ __typename?: 'Event' } & Pick<Event, 'shortId'>>;
              };
          }
      >;
    };
};

export type CurrentUserQueryVariables = {};

export type CurrentUserQuery = { __typename?: 'Query' } & {
  currentUser: { __typename?: 'UserGQL' } & Pick<
    UserGql,
    | 'shortId'
    | 'firstName'
    | 'username'
    | 'header'
    | 'lastName'
    | 'email'
    | 'logo'
    | 'role'
  > & {
      permissions: Array<
        { __typename?: 'PermissionGql' } & Pick<PermissionGql, 'uuid' | 'name'>
      >;
      uncompletedEvent: Maybe<
        { __typename?: 'Event' } & Pick<Event, 'shortId' | 'service' | 'title'>
      >;
      links: Maybe<
        Array<{ __typename?: 'LinkGql' } & Pick<LinkGql, 'link' | 'uuid'>>
      >;
      encoders: Maybe<
        Array<
          { __typename?: 'EncoderGql' } & Pick<
            EncoderGql,
            'uuid' | 'ip' | 'port' | 'type'
          >
        >
      >;
      settings: Array<
        { __typename?: 'SettingGql' } & Pick<SettingGql, 'key' | 'value'>
      >;
    };
};

export type UsersQueryVariables = {
  filters: FilterArgs;
};

export type UsersQuery = { __typename?: 'Query' } & {
  users: { __typename?: 'UserResults' } & Pick<UserResults, 'totalCount'> & {
      edges: Array<
        { __typename?: 'UserEdge' } & Pick<UserEdge, 'cursor'> & {
            node: { __typename?: 'UserGQL' } & Pick<
              UserGql,
              | 'shortId'
              | 'username'
              | 'firstName'
              | 'role'
              | 'lastName'
              | 'logo'
              | 'email'
            >;
          }
      >;
    };
};

export type UserQueryVariables = {
  shortId: Scalars['String'];
};

export type UserQuery = { __typename?: 'Query' } & {
  user: { __typename?: 'UserGQL' } & Pick<
    UserGql,
    | 'shortId'
    | 'username'
    | 'firstName'
    | 'header'
    | 'lastName'
    | 'email'
    | 'role'
    | 'ownerId'
  > & {
      permissions: Array<
        { __typename?: 'PermissionGql' } & Pick<PermissionGql, 'uuid' | 'name'>
      >;
      settings: Array<
        { __typename?: 'SettingGql' } & Pick<SettingGql, 'key' | 'value'>
      >;
    };
};

export const CreateEncoderDocument = gql`
  mutation createEncoder($encoder: CreateEncoderInput!) {
    createEncoder(encoder: $encoder) {
      uuid
      ip
      port
      type
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CreateEncoderGQL extends Apollo.Mutation<
  CreateEncoderMutation,
  CreateEncoderMutationVariables
> {
  document = CreateEncoderDocument;
}
export const CreateLinkDocument = gql`
  mutation createLink($link: String!) {
    createLink(link: $link) {
      uuid
      link
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CreateLinkGQL extends Apollo.Mutation<
  CreateLinkMutation,
  CreateLinkMutationVariables
> {
  document = CreateLinkDocument;
}
export const CreateUserDocument = gql`
  mutation createUser($user: CreateUserInput!) {
    createUser(user: $user) {
      shortId
      username
      firstName
      lastName
      email
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CreateUserGQL extends Apollo.Mutation<
  CreateUserMutation,
  CreateUserMutationVariables
> {
  document = CreateUserDocument;
}
export const DeleteEncoderDocument = gql`
  mutation deleteEncoder($input: DeleteUserEncoderInput!) {
    deleteEncoder(input: $input)
  }
`;

@Injectable({
  providedIn: 'root'
})
export class DeleteEncoderGQL extends Apollo.Mutation<
  DeleteEncoderMutation,
  DeleteEncoderMutationVariables
> {
  document = DeleteEncoderDocument;
}
export const EventsDocument = gql`
  query events($filters: FilterArgs!) {
    events(filters: $filters) {
      totalCount
      edges {
        cursor
        node {
          shortId
          title
          image
          dictationTime
          completed
          storagePath
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class EventsGQL extends Apollo.Query<EventsQuery, EventsQueryVariables> {
  document = EventsDocument;
}
export const EventDocument = gql`
    query event($input: SingleEventInput!) {
  event(input: $input) {
    shortId
    title
    service
    canEdit
    language
    encoder
    purgeFrequency
    link
    completed
    image
    zoomAPIKey
    useZoomCaptions
    uppercase
    transcoders{
    uuid
    port
    ip
    enabled
    encoder{
      uuid
      }
    }
    storagePath
    visibility
  }
}
    `;

@Injectable({
  providedIn: 'root'
})
export class EventGQL extends Apollo.Query<EventQuery, EventQueryVariables> {
  document = EventDocument;
}
export const AppendEventDocument = gql`
  mutation appendEvent($input: AppendEventInput!) {
    appendEvent(input: $input) {
      shortId
      title
      language
      words {
        startTime
        word
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class AppendEventGQL extends Apollo.Mutation<
  AppendEventMutation,
  AppendEventMutationVariables
> {
  document = AppendEventDocument;
}
export const OnEventAppendedDocument = gql`
  subscription onEventAppended($input: SingleEventInput!) {
    eventAppended(input: $input) {
      shortId
      language
      words {
        startTime
        word
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class OnEventAppendedGQL extends Apollo.Subscription<
  OnEventAppendedSubscription,
  OnEventAppendedSubscriptionVariables
> {
  document = OnEventAppendedDocument;
}
export const CreateEventDocument = gql`
mutation createEvent($input: CreateEventInput!) {
    createEvent(input: $input) {
      shortId
      profile {
        id
        name
        theme
        backgroundColor
        fontColor
        fontFamily
        fontSize
        language
        fullscreen
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CreateEventGQL extends Apollo.Mutation<
  CreateEventMutation,
  CreateEventMutationVariables
> {
  document = CreateEventDocument;
}
export const RemoveLinkDocument = gql`
  mutation removeLink($link: String!) {
    removeLink(link: $link)
  }
`;

@Injectable({
  providedIn: 'root'
})
export class RemoveLinkGQL extends Apollo.Mutation<
  RemoveLinkMutation,
  RemoveLinkMutationVariables
> {
  document = RemoveLinkDocument;
}
export const UpdateEventDocument = gql`
  mutation updateEvent($input: UpdateEventInput!) {
    updateEvent(input: $input) {
      shortId
      title
      service
      dictationTime
      completed
      canEdit
      encoder
      archived
      uppercase
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateEventGQL extends Apollo.Mutation<
  UpdateEventMutation,
  UpdateEventMutationVariables
> {
  document = UpdateEventDocument;
}
export const UpdateProfileDocument = gql`
  mutation updateProfile($user: UpdateUserInput!) {
    updateProfile(user: $user) {
      shortId
      username
      header
      firstName
      lastName
      email
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateProfileGQL extends Apollo.Mutation<
  UpdateProfileMutation,
  UpdateProfileMutationVariables
> {
  document = UpdateProfileDocument;
}
export const UpdateUserDocument = gql`
  mutation updateUser($user: CreateUserInput!) {
    updateUser(user: $user) {
      shortId
      username
      firstName
      lastName
      email
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UpdateUserGQL extends Apollo.Mutation<
  UpdateUserMutation,
  UpdateUserMutationVariables
> {
  document = UpdateUserDocument;
}
export const UploadsDocument = gql`
  query uploads($filters: FilterArgs!) {
    uploads(filters: $filters) {
      totalCount
      edges {
        cursor
        node {

          shortId
          filename
          createdAt
          status
          event {
            shortId
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UploadsGQL extends Apollo.Query<
  UploadsQuery,
  UploadsQueryVariables
> {
  document = UploadsDocument;
}
export const CurrentUserDocument = gql`
  query currentUser {
    currentUser {
      shortId
      firstName
      username
      header
      lastName
      email
      logo
      role
      permissions {
        uuid
        name
      }
      uncompletedEvent {
        shortId
        service
        title
      }
      links {
        link
        uuid
      }
      encoders {
        uuid
        ip
        port
        type
      }
      settings {
        key
        value
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class CurrentUserGQL extends Apollo.Query<
  CurrentUserQuery,
  CurrentUserQueryVariables
> {
  document = CurrentUserDocument;
}
export const UsersDocument = gql`
  query users($filters: FilterArgs!) {
    users(filters: $filters) {
      totalCount
      edges {
        cursor
        node {
          shortId
          username
          firstName
          role
          lastName
          logo
          email
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UsersGQL extends Apollo.Query<UsersQuery, UsersQueryVariables> {
  document = UsersDocument;
}
export const UserDocument = gql`
  query user($shortId: String!) {
    user(shortId: $shortId) {
      shortId
      username
      firstName
      header
      lastName
      email
      role
      ownerId
      permissions {
        uuid
        name
      }
      settings {
        key
        value
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class UserGQL extends Apollo.Query<UserQuery, UserQueryVariables> {
  document = UserDocument;
}
